const classesFor = ({fullscreen, column}) => {
  const fs = fullscreen ? 'fullscreen-bg' : ''
  const col = column ? 'vertical' : ''
  return `centre ${fs} ${col}`
}

export const Centre = ({children, fullscreen = false, column = false}) => (
  <div className={classesFor({fullscreen, column})}>
    {children}
  </div>
)
